import { Box } from "@mui/material";

interface Props {
  title: React.ReactNode;
  progress: React.ReactNode;
  actions: React.ReactNode;
  isColumnLayout: boolean;
}

/*
  Header row of the shipment detail pages. The two side columns share the
  leftover width equally, which keeps the progress stepper centred on the page
  rather than centred in whatever space the title and the action buttons leave
  over. The title column may shrink to zero so a long custom shipment name
  ellipsises instead of pushing the stepper off centre.
*/
export function ShipmentHeaderLayout(props: Props) {
  const { title, progress, actions, isColumnLayout } = props;

  return (
    <Box
      id="shipment-header"
      mb="1rem"
      sx={{
        display: "grid",
        gridTemplateColumns: isColumnLayout
          ? "1fr"
          : "minmax(0, 1fr) auto minmax(0, 1fr)",
        alignItems: isColumnLayout ? "stretch" : "baseline",
        columnGap: "1rem",
        rowGap: "1.5rem",
      }}
    >
      <Box id="shipment-header-title" sx={{ minWidth: 0 }}>
        {title}
      </Box>
      <Box id="shipment-header-progress" sx={{ justifySelf: "center" }}>
        {progress}
      </Box>
      <Box
        id="shipment-header-actions"
        sx={{
          justifySelf: isColumnLayout ? "stretch" : "end",
          minWidth: "fit-content",
        }}
      >
        {actions}
      </Box>
    </Box>
  );
}
